import { Input } from 'antd'
import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const StyledTab = styled(StyledTabs)`
  .ant-tabs-content {
    overflow: ${props => (props?.overflow ? props?.overflow : 'scroll')};
    overflow-x: ${props => (props?.overflowX ? props?.overflowX : 'auto')};
    &::-webkit-scrollbar {
      display: '';
    }
  }

  .ant-tabs-nav {
    width: ${props => (props.width ? props?.width : '30%')} !important;
  }
`
export const SubmitFlex = styled(Flex)`
  gap: 20px;
  padding: 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`
export const MenuFlex = styled(Flex)`
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
`
export const Wrapper = styled(Flex)`
  padding: 20px 20px 20px 0;
  gap: 5px;
`
export const StyledP = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 16px;
  color: ${COLORS.BLACK};
  margin-bottom: 0;
  margin-right: 5px;
`
export const RangeValues = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 16px;
  color: ${COLORS.GREY_T_30};
  background: ${COLORS.GREY_T_95};
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 5px;
  padding: 5px 10px;
`
export const SearchInput = styled(Input)`
  ::placeholder {
    font-size: 16px;
  }
  width: ${props => (props.width ? props.width : '250px')} !important;
  height: ${props => (props.height ? props.height : '40px')};
  border-radius: 8px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    border-color: #e9e9e9;
    box-shadow: none;
  }
  :hover {
    border-color: #e9e9e9;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #e9e9e9 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-right-width: 0px !important;
  }
`
